import React from "react";
import Text from "../../styleguide/Text";
import SelectableChecker from "./SelectableItem/SelectableChecker";

function Checkbox({
  name,
  label,
  labelAlign = "right",
  disabled,
  checked,
  onChange,
  textVariant,
  className,
  CustomLabelComponent,
  interactiveRow,
}: {
  name?: string;
  label?: string;
  labelAlign?: "left" | "right";
  disabled?: boolean;
  checked?: boolean;
  onChange?: (isChecked: boolean) => void;
  textVariant?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "body1" | "body2";
  className?: string;
  CustomLabelComponent?: React.ReactNode;
  interactiveRow?: boolean;
}) {
  const handleChange = (isChecked: boolean) => {
    onChange && onChange(isChecked);
  };

  const getCustomLabelComponent = () => {
    if (CustomLabelComponent) {
      return CustomLabelComponent;
    }
    return (
      <Text
        forId={name}
        marginRight={1}
        component="label"
        className={`${name ? "cursor-pointer" : ""} ml-2`}
        variant={textVariant}>
        {label}
      </Text>
    );
  };

  if (interactiveRow) {
    return (
      <label
        className={`flex min-h-[44px] w-full max-w-2xl cursor-pointer items-center gap-3 rounded-control px-2 py-2 transition-colors hover:bg-surface-hover focus-within:bg-surface-hover [&_input]:!h-6 [&_input]:!w-6 ${
          className ?? ""
        }`}>
        <SelectableChecker
          type="checkbox"
          id={name}
          name={name ?? "checkbox"}
          checked={checked}
          onChange={handleChange}
          isDisabled={disabled}
        />
        <span className="text-sm font-medium leading-5 text-slate-900">
          {label}
        </span>
      </label>
    );
  }

  return (
    <div className={`flex items-center justify-between ${className ?? ""}`}>
      {label && labelAlign === "left" && getCustomLabelComponent()}
      <SelectableChecker
        type="checkbox"
        id={name}
        name={name ?? "checkbox"}
        checked={checked}
        onChange={handleChange}
        isDisabled={disabled}
      />

      {label && labelAlign === "right" && getCustomLabelComponent()}
    </div>
  );
}

export default Checkbox;
